import { Component, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { AcessoService } from '../../service/acesso/acesso.service';
import { LocalStorage } from 'src/app/service/classes/localstorage/LocalStorage';
import { Crypto } from 'src/app/service/classes/crypto/crypto';

@Injectable({ providedIn: 'root' })
export class GeradorRelatoriosService {
  localStorage: LocalStorage = new LocalStorage();
  headers = new HttpHeaders();
  filial: string = '';
  cabecalho: any = null;
  data: any = new Date();
  mes: number = this.data.getMonth() + 1;
  ano: number = this.data.getFullYear();
  url_acesso: any = this.acesso.validarUrl();
  competencia: string = this.ano.toString() + this.mes.toString();

  constructor(private http: HttpClient, private acesso: AcessoService) {
    if (localStorage.getItem('util') != null) {
      this.localStorage = JSON.parse(new Crypto().decryptUsingAES256(localStorage.getItem('util')));
      this.cabecalho = this.headers.append('sessao', this.localStorage.Sessao);
      this.filial = this.localStorage.FilialAtual.toString();
    }
  }

  buscarExecucao() {
    return this.http.get(`${this.url_acesso}execucao-tarefas/tipos-execucao`, {
      headers: this.cabecalho,
    });
  }

  buscarParametros(codigoTipoExecucao: string) {
    return this.http.get(
      `${this.url_acesso}execucao-tarefas/parametros-programa/${codigoTipoExecucao}/${1}`,
      {
        headers: this.cabecalho,
      }
    );
  }

  buscarProgramaDetalhe(codigoTipoExecucao: string, codigoPrograma: string, tipoPrograma: string) {
    return this.http.get(
      `${this.url_acesso}execucao-tarefas/parametros-programa-detalhe/${codigoTipoExecucao}/${codigoPrograma}/${tipoPrograma}`,
      {
        headers: this.cabecalho,
      }
    );
  }


  buscarCriticaParametros(linha: string, codigoPrograma: string) {
    return this.http.get(
      `${this.url_acesso}execucao-tarefas/critica-parametros/${codigoPrograma}/${linha}`,
      {
        headers: this.cabecalho,
      }
    );
  }
}
